import { IInventoryUniqueItem } from './IInventoryUniqueItem';

export class IMobileInventoryCount {
  inventoryCountId: string;
  inventoryTemplateId: string;
  equipmentKeyId: number;
  startDate: Date;
  endDate: Date;
  jobId: string;
  jobName: string;
  jobDescription: string;
  projectManagerId: string;
  projectManagerName: string;
  modifiedBy: string;
  modifiedDate: Date;
  isActive: boolean;
  isAssignTemplate: boolean;
  inventoryStatusId: string;
  inventoryStatusName: string;
  inventoryStatusDescription: string;
  relatedUniqueItems: IInventoryUniqueItem[];
  warehouseId: number;
  warehouseName: string;
  subLocationId: number;
  subLocationName: string;
}
